export default {
  title: { //各页面标题
    home: '首页',
    sec_kill: '限时购',
    product_list: '产品列表',
    search: '钻石搜索',
    search_item: '钻石搜索',
    product_detail: '钻石详情',
    share_with_money: '分享领现金',
    share_page: '分享领现金',
    share_get_page: '分享领现金',
    ssh: '搜饰盒',
    download_page: 'APP下载',
    share_img: '搜饰盒分享',
    fang_jia_tong_zhi: '搜饰盒放假通知',
  },
  // 页面文案
  home: {

  },
  // 其他
  exchange_support: '支持无限换戴',
  share_img_button: '长按图片保存至手机',
  token_required: '请先登陆',
  token_expire: '登陆或已过期，请重新登陆',
  price_sign: '￥',
  price_text: '售价',
  empty: '没有更多了',
  loosing: '释放即可刷新...',
  loading: '加载中...',
  reload: {
    success: '刷新成功',
    failed: '刷新失败',
  },

  mall_home:{
    location:'香港特別行政區',
    my_account:'我的賬戶',
    account_num:'賬號',
    logout:'退出登錄',
    please:'請先',
    login:'登錄',
    register:'註冊',
    infor:'個人信息',
    my_order:'我的訂單',
    my_wishlist:'我的購物車',
    jewellery_box:'搜飾盒',
    fine_jewellery:'珠寶首飾',
    brand:'品牌世界',
    download:'app下載',
    hot: '搜饰红人',
    gia: '鑽石定制',
    jewellery_type:'類別',
    brand_type:'類別',
    new_collection:'全新系列',
    exchange:'搜飾盒珠寶無限換戴',
    find_store:'前往附近的體驗中心',
    explore_products:'更多體驗等妳來',
  }
}



// WEBPACK FOOTER //
// ./src/lang/cn.js